import { Box, Grid, useMediaQuery } from "@mui/material";
import { PoweredBy } from "components/PoweredBy/PoweredBy";
import { useBreak } from "hooks/useBreak";
import { useEffect, useRef, useState } from "react";
import { useGet, useSet } from "state/jotai";
import { active_project } from "state/store.global";

const PropertyCard = ({ units, createGroupArr, x, buttonsLabel, GroupNames, showDiff, handleScroll, propertyRef }) => {
    const isDesktop      = useBreak('md_up')
    let   isValuePresent = {};
     const { pin, pid } = useGet(active_project);
    const compareProperty = GroupNames?.map((gn) => {
      let floorplan = '';
      let idx       = 0;
      let prisValue = '';
      let prisTekstDK = ''
      let prisPost  = '';
      let groupArr  = [];
      let data      = [];
      let unitsData = [];
        data      = units.map((i, j) => {
        floorplan = i.Gallery?.Floorplan?.Url;
        idx       = j < i.Gallery?.ListOfPhotos.length ? j : 0;

        const isRent = i.Data?.SalesTypeLejelejlighed.Value
        prisValue = i.Data?.[isRent ? 'Husleje' : 'Kontantpris']?.Value;
        prisPost  = i.Data?.[isRent ? 'Husleje' : 'Kontantpris']?.Postfix;
        prisTekstDK  = i.Data?.Pris_Tekst_DK?.Value;
        groupArr  = createGroupArr({ i, comparePropertyNames: x });
      
        if(groupArr[gn]?.length) {
          isValuePresent = {};
          unitsData      = groupArr[gn]?.map((item, index) => {
            // collect values across units for this label to populate isValuePresent
            const xy = units.map((sUnit, jUnit) => {
              const groupArrUnit = createGroupArr({ i:sUnit, comparePropertyNames: x });
              const a            = groupArrUnit[gn]?.filter((gItem, index) => {
            
                if(gItem.Label === item.Label){
                  // mark that at least one unit has a meaningful value (not empty / 0 / 999.999)
                  const candidate = gItem?.Value;
                  const candidateIsNumber = typeof candidate === 'number' || (!isNaN(parseFloat(candidate)) && String(candidate).trim() !== '');
                  const notEmpty = !(
                    candidate === "" ||
                    candidate === null ||
                    candidate === undefined ||
                    candidate === "999.999" ||
                    candidate === "999999" ||
                    candidate === 0 ||
                    candidate === "0"
                  );
                  if(notEmpty && !isValuePresent[item.Label]) {
                    isValuePresent[item.Label] = true;
                  }
                  return true
                }
   
                return false;
              })
              return a?.length ? a[0].Value: []
            })
            
            // rawValue preserved for robust checking later
            const rawValue = item.Value;
            const value        = 
                  item.Value === true
                ? buttonsLabel?.filter(
                    (btn) => btn.UILabelProperty === "Ja"
                  )[0]?.Label
                : item.Value === false
                ? buttonsLabel?.filter(
                    (btn) => btn.UILabelProperty === "Nej"
                  )[0]?.Label
                :    item.Value;
            const label       = item.Label;
            const postfix     = item.Postfix;
            const IsDifferent = item?.IsDifferent;
            const ShowValue   = item.ShowValue;

            // include propertyID & rawValue to allow filtering later (and for PropertyID 310 rule)
            const propertyID = item.PropertyID;

            // For Facilities we want to keep the raw boolean/number information too.
            // We'll store both: display 'value' (converted string labels) and rawValue/propertyID
            return {
              label,
              postfix,
              value: (value === "" || value === null || value === "0" || value === "999.999") 
                       ? isValuePresent[item.Label] ? "-" : "" 
                       : /* if it's facilities we might want to keep raw boolean/number values;
                          but to preserve existing UI we keep this converted value for display */
                       (gn === 'Faciliteter' || gn === 'Facilities') ? item.Value : value,
              rawValue,      // the original item.Value (boolean/number/string)
              propertyID,
              IsDifferent,
              ShowValue
            }
          })
          .filter((d) => {
          if(d.label === 'Bolignr.') return false

          // Facilities: support both Danish and English group names
          if(gn === "Faciliteter" || gn === "Facilities") {
            // ALWAYS show PropertyID 310 regardless of its value
            if (d.propertyID === 310 && pid== 3) return true;

            // If rawValue === true -> show
            if (d.rawValue === true) return true;

            // If rawValue is a number and not zero -> show
            if (typeof d.rawValue === "number" && d.rawValue !== 0) return true;

            // If rawValue is a string that is non-empty and not '0' or '999.999' -> show
            if (typeof d.rawValue === "string") {
              const rv = d.rawValue.trim();
              if (rv !== "" && rv !== "0" && rv !== "999.999") return true;
            }

            // Otherwise do not show this facility
            return false;
          }

          // keep same Økonomi rules (exclude rent-related fields for non-rent units)
          if(gn === 'Økonomi' && !isRent && (d.label === "Husleje" || d.label === "Indflytningspris" || d.label === "Depositum" || d.label === "Forudbetalt husleje" 
            || d.label === "Aconto vand" || d.label === "Aconto varme"
          )) return false
           
            return !(d.value === "" || d.value === null || d.value === undefined || d.value === "0" || d.value === 0 ||  d.value === "999.999")
          })
        } 
        return {
          unitsData
        }
      })
      return {
        label: gn,
        data,
        idx,
        prisValue,
        prisPost,
        prisTekstDK
      }
    }).filter((f) => {
      if(f.prisValue !== "" && f.label === "Økonomi") return false
      return true
    })
    
    return (
        <div
        style={{
            padding: !isDesktop ? '0 0 0 16px': '0 0 0 48px',
            width  : '100%',
          }}
          >
        <div
         ref      = {propertyRef}
         onScroll = {(e) => {
          e.preventDefault()
          handleScroll(e, 'normalSwiper')
        }}
              style={{ overflow: 'auto', height: '100%', position: "relative",
          }}>
          {
            compareProperty?.map((g, i)=> {
              const hideLabel = g?.data?.filter((gItem) => gItem?.unitsData?.length)
              let gud = []
              g?.data.map((gi, j) => {
                gud = gi?.unitsData?.length ? gi?.unitsData?.filter(u => {
                  if(showDiff && !u?.IsDifferent) return false
                  return true
                }) : []
            })
                return (
                  gud.length > 0 && <div key = {i}>
                   { Boolean(hideLabel?.length) &&
                   <div key   = {i}>
                   <div className="h3" style = {{ width: `${((!isDesktop ? 250 : 450)*units?.length + (4*(units?.length - 1)))}px`, background: clr?.primary, color: clr?.primary_text, height: '57px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: !i ? "6px 6px 0px 0px" : 0 }}>
                        {g?.label}
                    </div>
                    <div style = {{ display: 'flex' }}>
                      {
                          g?.data.map((gi, j) => {
                            const gud = gi?.unitsData?.length ? gi?.unitsData?.filter(u => {
                              if(showDiff && !u?.IsDifferent) return false
                              return true
                            }) : []
                          return(
                            <div key = {i+j} style = {{ minWidth: !isDesktop ? "250px" : "450px", maxWidth:  !isDesktop ? "250px" : "450px",  marginRight: j + 1 === g?.data?.length ? '0' : '4px' }}>
                             
                              { gud?.length ? 
                              gud?.map((item, index) => {
                               
                              const value        = 
                                    item.value === true
                                  ? buttonsLabel?.filter(
                                      (btn) => btn.UILabelProperty === "Ja"
                                    )[0]?.Label
                                  : item.value === false
                                  ? buttonsLabel?.filter(
                                      (btn) => btn.UILabelProperty === "Nej"
                                    )[0]?.Label
                                  :    item.value;
                              const label   = item.label;
                              const postfix = item.postfix;
  
                                    // if ( showDiff && !item.IsDifferent ) { return null }
                              if (item.ShowValue == false) {
                                return null;
                              }
                              // for getting  differnve value
                              if (showDiff && !item?.IsDifferent) {
                                return null;
                              }
                              return (
                                <Box
                                key = {i+j+index}
                                >
                                  <Box>
                                    <Grid>
                                      <Grid item key = {i} xs = {4}>
                                        <Box
                                          sx={{
                                            py             : 1.1,
                                            lineHeight     : 1.5,
                                            backgroundColor: item?.IsDifferent
                                              ? `${clr?.footer_bgcolor}`
                                                        :    "#EFEFEF",
                                            px          : 3,
                                            borderBottom: item?.IsDifferent
                                              ? "1px solid #fff"
                                                    :    "1px solid #0000001f",
                                              height: "62px"
                                          }}
                                        >
                                          <Box className="h4">
                                            {label}
                                          </Box>
                                          <Box className="paragraph1-light">
                                            {value}
                                            {postfix}
                                          </Box>
                                        </Box>
                                      </Grid>
                                    </Grid>
                                  </Box>
                                </Box>
                              );
                            })
                          : 
                          <Box sx = {{ height: '1px'}}>
                          </Box>
                          }
                            </div>
                          )
                        })
                      }
                  </div>
                    </div>
                  }
                  </div>
                )
            })
          }
            <PoweredBy clr="#004337"/>
          </div>
          </div>
   
    )
}

export default PropertyCard;
